module.exports = __webpack_public_path__ + "static/media/skoda_logo.b6391361.png";